import usePrequal from '../../resources/prequal/usePrequal';
import useMerchant from '../../resources/merchant/read';

const usePrequalMerchant = () => {
  const { data: prequal } = usePrequal();
  return useMerchant(prequal.merchantId, { suspense: true });
};

export default usePrequalMerchant;
